import useScheduleStore from "@/store/schedule";
import { Button, Group, Stack, Text } from "@mantine/core";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";

export function TimSelectorFooter() {
  const {
    selectedAppointmentDate,
    setSelectedAppointmentDate,
    setSelectedAppointmentTime,
  } = useScheduleStore();

  const goNext = () => {
    setSelectedAppointmentDate({
      selectedAppointmentDate: new Date(
        new Date(selectedAppointmentDate).setDate(
          new Date(selectedAppointmentDate).getDate() + 1
        )
      ),
    });
    setSelectedAppointmentTime({
      selectedAppointmentTime: [],
    });
  };
  const goPrev = () => {
    setSelectedAppointmentDate({
      selectedAppointmentDate: new Date(
        new Date(selectedAppointmentDate).setDate(
          new Date(selectedAppointmentDate).getDate() - 1
        )
      ),
    });
    setSelectedAppointmentTime({
      selectedAppointmentTime: [],
    });
  };
  const goToday = () => {
    setSelectedAppointmentDate({
      selectedAppointmentDate: new Date(),
    });
    setSelectedAppointmentTime({
      selectedAppointmentTime: [],
    });
  };
  const isToday =
    new Date()?.getDate() === new Date(selectedAppointmentDate)?.getDate();

  return (
    <Group justify="space-between" align="center" pt="5" px="md">
      <Button
        size="compact-xs"
        onClick={goPrev}
        variant="light"
        disabled={isToday}
      >
        <Group gap="xs">
          <IconChevronRight size={15} />
          <Text size="xs">روز قبل</Text>
        </Group>
      </Button>
      <Stack>
        {/* <Text size="sm">
          {moment(currentDate)?.format("dddd jD jMMMM jYYYY")}
        </Text> */}
        {!isToday && (
          <Button
            size="compact-xs"
            color="blue"
            variant="light"
            onClick={goToday}
          >
            <Text size="xs">برو به امروز</Text>
          </Button>
        )}
      </Stack>

      <Button size="compact-xs" onClick={goNext} variant="light">
        <Group gap="xs">
          <Text size="xs">روز بعد</Text>
          <IconChevronLeft size={15} />
        </Group>
      </Button>
    </Group>
  );
}
